import { stat } from "fs";

const menu = {
  state: {
    data: []
  },
  mutations: {
    SET_MENU: (state, menu) => {
      state.data = menu
    }
  }
}

export default menu


// WEBPACK FOOTER //
// ./src/store/modules/menu.js